import { render, staticRenderFns } from "./NewCommunityFamily.vue?vue&type=template&id=3c4fbe40&scoped=true&"
import script from "./NewCommunityFamily.vue?vue&type=script&lang=js&"
export * from "./NewCommunityFamily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4fbe40",
  null
  
)

export default component.exports